<template>
  <div id="about">
    <v-container>
      <v-row v-for="(item, index) in aboutData" :key="index">
        <v-col v-if="index % 2 == 0">
          <div class="content-section">
            <h2 class="main-color about-title">{{ item.title }}</h2>
            <div class="body" v-html="item.body"></div>
          </div>
        </v-col>
        <v-col class="image-section" v-else>
          <v-img
            :src="item.img != '' ? item.img : ''"
            max-width="400px"
          ></v-img>
        </v-col>

        <v-col v-if="index % 2 != 0">
          <div class="content-section">
            <h2 class="main-color about-title">{{ item.title }}</h2>
            <div class="body" v-html="item.body"></div>
          </div>
        </v-col>
        <v-col class="image-section" v-else>
          <v-img
            :src="item.img != '' ? item.img : ''"
            max-width="400px"
          ></v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      aboutData: []
    };
  },
  methods: {
    getAboutData() {
      this.$http
        .get(this.getApiUrl + "/about_us/get_data", {
          headers: {
            locale: localStorage.locale
          }
        })
        .then(response => {
          if (response.data.status.error == false) {
            this.aboutData = response.data.data;
          }
        });
    }
  },
  mounted() {
    this.getAboutData();
  }
};
</script>

<style lang="scss" scoped>
#about {
  margin-top: 2rem;
  .content-section {
    .about-title {
      font-size: 2rem;
      margin-bottom: 1rem;
    }
  }
  .image-section {
    .v-image {
      margin: 0 auto !important;
    }
  }
}
</style>
